(function () {
  const root = document.querySelector("[data-pf-pdp]");
  if (!root || !window.PF_PDP) return;
  const data = window.PF_PDP;
  let variants = data.variants || [];
  const form = root.querySelector("[data-pf-form]");
  const idInput = root.querySelector("[data-pf-id]");
  const atc = root.querySelector("[data-pf-atc]");
  const atcLabel = atc.querySelector(".pf-atc__label");
  const atcTotal = atc.querySelector(".pf-atc__total");
  const errEl = root.querySelector("[data-pf-err]");
  const mainImg = root.querySelector("[data-pf-main]");

  const LEN_ORDER = ["Standard", "Kurz", "Lang", "Extra Lang", "Ultra Lang"];
  const SIZE_ORDER = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "1X", "2X", "3X"];
  const PF_COLORS = {
    "Schwarz": "#1a1a1a", "Chive": "#4a5a39", "Royal Blue": "#2b4ba0", "Wood Thrush": "#6b4e3a",
    "Midnight Blue": "#1c2a48", "Chocolate Martini": "#432f26", "Weiß": "#f3f1ec", "Silent Storm": "#8a8f96",
    "Autumn Chestnut": "#7c4a30", "Valiant Poppy": "#c0392b", "Red Mahogany": "#6e2f2a", "Deep Red Grey": "#5f4b4b",
    "Burro": "#c9a66b", "Deep Aquamarine": "#1f6b6b", "Forest Night": "#2b3a2e", "Oat Milk": "#e3d9c6",
    "Egg Cream White": "#efe9db", "Rain Forest": "#335c3f", "Sepia": "#6a4b35", "Cinnabar": "#c7472e",
    "Atlantic Deep": "#1d3a54", "Dusky Evening purple": "#5a4a66", "Primrose Pink": "#e7b3c0",
    "Purple Sandalwood": "#6e5668", "Cloud Shore": "#c6ccd2", "Light Azure": "#8fb8d6", "Candy Pink": "#e56fa0",
    "Arctic": "#d4dee1", "Baby Blue": "#a9c8e0", "Buckskin": "#b5885c", "Deep Orchid": "#8e3a7a",
    "Raspberry Rose": "#b03a5b", "Icelandic Blue": "#6b94b0", "Nebula Purple": "#453869", "Jacaranda": "#6a5a9a"
  };
  function hexFor(c) { return PF_COLORS[c] || "#9a9488"; }
  function isLight(hex) {
    const h = hex.replace("#", "");
    return 0.299 * parseInt(h.slice(0, 2), 16) + 0.587 * parseInt(h.slice(2, 4), 16) + 0.114 * parseInt(h.slice(4, 6), 16) > 205;
  }
  function parseSize(raw) {
    const m = String(raw || "").match(/^(.+?)\s*\((.+)\)$/);
    return m ? { base: m[1].trim(), length: m[2].trim() } : { base: String(raw || "").trim(), length: "Standard" };
  }
  function sortBy(arr, order) { return order.filter((x) => arr.includes(x)).concat(arr.filter((x) => !order.includes(x))); }

  let colors = [], byColor = {}, lenByColor = {}, baseByCL = {}, variantMap = {};
  function buildIndexes() {
    variants.forEach((v) => {
      const p = parseSize(v.size); v._len = p.length; v._base = p.base;
      if (!byColor[v.color]) { byColor[v.color] = []; colors.push(v.color); }
      byColor[v.color].push(v);
      (lenByColor[v.color] = lenByColor[v.color] || []).includes(v._len) || lenByColor[v.color].push(v._len);
      const clk = v.color + "|" + v._len;
      (baseByCL[clk] = baseByCL[clk] || []).includes(v._base) || baseByCL[clk].push(v._base);
      variantMap[v.color + "|" + v._len + "|" + v._base] = v;
    });
    for (const c in lenByColor) lenByColor[c] = sortBy(lenByColor[c], LEN_ORDER);
    for (const k in baseByCL) baseByCL[k] = sortBy(baseByCL[k], SIZE_ORDER);
  }
  function lengthsForColor(c) { return lenByColor[c] || ["Standard"]; }
  function basesFor(c, l) { return baseByCL[c + "|" + l] || []; }
  function resolve(c, l, b) {
    return variantMap[c + "|" + l + "|" + b] ||
      (baseByCL[c + "|" + l] ? variantMap[c + "|" + l + "|" + baseByCL[c + "|" + l][0]] : null) ||
      (byColor[c] ? byColor[c][0] : null);
  }

  let state = { color: "", length: "Standard", base: "" };
  let tier = 1;

  function fillSelect(sel, opts, val) {
    const frag = document.createDocumentFragment();
    opts.forEach((o) => {
      const op = document.createElement("option");
      op.value = o; op.textContent = o;
      if (o === val) op.selected = true;
      frag.appendChild(op);
    });
    sel.innerHTML = ""; sel.appendChild(frag);
  }
  function updateGallery(color) {
    const v = byColor[color] && byColor[color][0];
    if (v && v.image && mainImg) mainImg.src = v.image;
    const first = resolve(color, state.length, state.base);
    if (first && idInput) idInput.value = first.id;
  }

  function buildItems(container, n) {
    container.innerHTML = "";
    for (let i = 1; i <= n; i++) {
      const row = document.createElement("div"); row.className = "pf-item";
      const head = document.createElement("div"); head.className = "pf-item__head";
      const lab = document.createElement("span"); lab.className = "pf-item__n"; lab.textContent = "Hose " + i;
      const dot = document.createElement("span"); dot.className = "pf-item__dot";
      head.appendChild(lab); head.appendChild(dot);

      const ctrls = document.createElement("div"); ctrls.className = "pf-item__ctrls";
      const cSel = document.createElement("select"); cSel.className = "pf-sel pf-sel--color"; cSel.setAttribute("aria-label", "Farbe Hose " + i);
      const lSel = document.createElement("select"); lSel.className = "pf-sel"; lSel.setAttribute("aria-label", "Länge Hose " + i);
      const sSel = document.createElement("select"); sSel.className = "pf-sel"; sSel.setAttribute("aria-label", "Größe Hose " + i);
      fillSelect(cSel, colors, state.color);
      function setDot() { const hx = hexFor(cSel.value); dot.style.background = hx; dot.classList.toggle("pf-item__dot--light", isLight(hx)); }
      function refreshLen() { const lens = lengthsForColor(cSel.value); fillSelect(lSel, lens, lens.includes(state.length) ? state.length : lens[0]); refreshSize(); }
      function refreshSize() { const bases = basesFor(cSel.value, lSel.value); fillSelect(sSel, bases, bases.includes(state.base) ? state.base : bases[0]); }
      cSel.addEventListener("change", () => { setDot(); refreshLen(); if (i === 1) updateGallery(cSel.value); });
      lSel.addEventListener("change", refreshSize);
      setDot(); refreshLen();
      ctrls.appendChild(cSel); ctrls.appendChild(lSel); ctrls.appendChild(sSel);
      row.appendChild(head); row.appendChild(ctrls);
      container.appendChild(row);
    }
  }

  function updateAtc() {
    const card = root.querySelector(".pf-btier.is-active");
    if (atcLabel) atcLabel.textContent = "In den Warenkorb";
    if (atcTotal) atcTotal.textContent = card ? card.getAttribute("data-total") : "39,95 €";
  }

  function setTier(n) {
    tier = n;
    root.querySelectorAll(".pf-btier").forEach((t) => {
      const on = Number(t.getAttribute("data-tier")) === n;
      t.classList.toggle("is-active", on);
      const head = t.querySelector(".pf-btier__head");
      if (head) head.setAttribute("aria-pressed", on ? "true" : "false");
      const items = t.querySelector("[data-items]");
      if (!items) return;
      if (on) buildItems(items, n); else items.innerHTML = "";
    });
    updateAtc();
  }

  root.querySelectorAll(".pf-btier__head").forEach((head) => {
    const n = Number(head.closest(".pf-btier").getAttribute("data-tier")) || 1;
    head.addEventListener("click", () => setTier(n));
    head.addEventListener("keydown", (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setTier(n); } });
  });

  function openDrawer() {
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent("variant:add", { bubbles: true, detail: {} }));
    if (typeof window.plCartOpen === "function") window.plCartOpen();
  }

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    if (errEl) errEl.hidden = true;
    const active = root.querySelector(".pf-btier.is-active [data-items]");
    const items = {};
    if (active) active.querySelectorAll(".pf-item").forEach((row) => {
      const s = row.querySelectorAll("select");
      const v = resolve(s[0].value, s[1].value, s[2].value);
      if (v) items[v.id] = (items[v.id] || 0) + 1;
    });
    const payload = Object.keys(items).map((id) => ({ id: Number(id), quantity: items[id] }));
    if (!payload.length) { if (errEl) { errEl.textContent = "Bitte Variante wählen."; errEl.hidden = false; } return; }
    atc.disabled = true;
    if (atcLabel) atcLabel.textContent = "Wird hinzugefügt"; if (atcTotal) atcTotal.textContent = "…";
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: payload }),
      });
      if (!res.ok) throw new Error("add");
      openDrawer(); atc.disabled = false; updateAtc();
    } catch (err) {
      atc.disabled = false;
      if (atcLabel) atcLabel.textContent = "Nochmal versuchen"; if (atcTotal) atcTotal.textContent = "";
    }
  });

  root.querySelectorAll("[data-thumb-src]").forEach((btn) => {
    btn.addEventListener("click", () => {
      root.querySelectorAll("[data-thumb-src]").forEach((x) => x.classList.remove("is-active"));
      btn.classList.add("is-active");
      const src = btn.getAttribute("data-thumb-src");
      if (mainImg && src) mainImg.src = src;
    });
  });

  function init() {
    if (!variants.length) return;
    colors = []; byColor = {}; lenByColor = {}; baseByCL = {}; variantMap = {};
    buildIndexes();
    const f = variants[0];
    state = { color: f.color, length: f._len, base: f._base };
    if (idInput) idInput.value = f.id;
    setTier(1);
    updateAtc();
  }

  const jsonUrl = root.getAttribute("data-variants-url");
  if (jsonUrl) {
    fetch(jsonUrl).then((r) => r.json()).then((all) => { if (Array.isArray(all) && all.length) variants = all; init(); }).catch(init);
  } else { init(); }
})();
